<div class="pointer-events-none fixed inset-0 z-0 isolate overflow-hidden bg-base-2" aria-hidden="true">
    <div
        class="absolute left-[-15%] top-[-20%] h-[65vmax] w-[65vmax] animate-blob-drift-1 rounded-full bg-[radial-gradient(circle_at_center,rgb(0_204_204/70%),transparent_66%)] blur-[clamp(42px,6vw,92px)] will-change-transform motion-reduce:animate-none"
    ></div>
    <div
        class="absolute right-[-18%] top-[-5%] h-[60vmax] w-[60vmax] animate-blob-drift-2 rounded-full bg-[radial-gradient(circle_at_center,rgb(0_100_114/88%),transparent_68%)] blur-[clamp(42px,6vw,92px)] will-change-transform [animation-delay:-7s] motion-reduce:animate-none"
    ></div>
    <div
        class="absolute bottom-[-28%] left-[20%] h-[70vmax] w-[70vmax] animate-blob-drift-3 rounded-full bg-[radial-gradient(circle_at_center,color-mix(in_srgb,var(--element-base-1,#23233c)_60%,rgb(0_100_114/85%)),transparent_70%)] blur-[clamp(42px,6vw,92px)] will-change-transform [animation-delay:-13s] motion-reduce:animate-none"
    ></div>
</div>
